export default {
  eyebrow: 'Portale partner',
  title: 'Commissioni di elaborazione',
  description:
    'Paghi tu le commissioni di Stripe su ogni pagamento online. La commissione di elaborazione impostata qui viene addebitata ai tuoi ristoranti per coprirle, a meno che un ristorante non abbia una tariffa propria.',
  card_title: 'Commissione di elaborazione predefinita',
  hint: 'Percentuale in %, più un importo fisso e un importo minimo facoltativi per pagamento. «Qualsiasi metodo di pagamento» si applica quando non esiste una tariffa specifica per il metodo. Una modifica si applica ai pagamenti effettuati dopo il salvataggio.',
  hint_single:
    'La commissione di elaborazione si applica a ogni metodo di pagamento online che non ha una tariffa propria. Una modifica si applica ai pagamenti effettuati dopo il salvataggio.',
  hidden_rates:
    'Alcuni metodi di pagamento hanno anche una tariffa propria, impostata dal supporto della tua piattaforma. Questa viene applicata al posto di questa tariffa.',
  empty: {
    title: 'Nessuna commissione di elaborazione predefinita impostata',
    description:
      'Finché non ne imposti una, o non confermi di non addebitare alcuna commissione di elaborazione ai tuoi ristoranti, i tuoi ristoranti su Stripe non possono andare online e quelli attivi non ricevono pagamenti online (i contanti funzionano comunque).',
  },
  consent: {
    give: 'Paghiamo noi le commissioni di Stripe (conferma margine 0%)',
    given_title: 'Margine 0% confermato',
    given:
      'Confermato da {{name}} il {{date}}: ai ristoranti senza una tariffa propria non viene addebitata alcuna commissione di elaborazione e tu paghi le commissioni di Stripe sui loro pagamenti.',
    unknown_manager: 'un ex manager',
    withdraw: 'Revoca',
    withdraw_confirm: {
      title: 'Ritirare la conferma del margine dello 0%?',
      description:
        'I ristoranti senza una tariffa propria non potranno quindi andare online, e quelli già online smetteranno di accettare pagamenti online finché non imposterai una tariffa o non confermerai di nuovo.',
    },
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  toasts: {
    load_error: 'Impossibile caricare le tue commissioni di elaborazione.',
    failed_to_save_changes: 'Impossibile salvare le tue commissioni di elaborazione.',
    changes_got_saved: 'Commissioni di elaborazione salvate',
    consent_given: 'Margine 0% confermato',
    consent_withdrawn: 'Conferma revocata',
  },
};
